// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-data-type-icon_dimension.dl-data-type-icon {
  color: var(--g-color-text-positive);
}
.dl-data-type-icon_measure.dl-data-type-icon {
  color: var(--g-color-text-info);
}
.dl-data-type-icon_parameter.dl-data-type-icon {
  color: var(--g-color-text-utility);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DataTypeIcon/DataTypeIcon.scss"],"names":[],"mappings":"AAGI;EACI,mCAAA;AAFR;AAKI;EACI,+BAAA;AAHR;AAMI;EACI,kCAAA;AAJR","sourcesContent":[".dl-data-type-icon_dimension.dl-data-type-icon {\n  color: var(--g-color-text-positive);\n}\n.dl-data-type-icon_measure.dl-data-type-icon {\n  color: var(--g-color-text-info);\n}\n.dl-data-type-icon_parameter.dl-data-type-icon {\n  color: var(--g-color-text-utility);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
